import React, { useEffect, useRef } from 'react';

import { TextField } from '@mui/material';

import Styles from '../lib/Styles';
import classes from './SelectBoxedField.module.scss';

export default function SelectCity(props: any) {
  const {selectedCity, setSelectedCity, onChangeCity, readOnly = false, required = false } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;
  const maxNumberOfCharacters: number = 100;

  useEffect(() => {
    if (initialValue.current) {
      setSelectedCity(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setSelectedCity])

  const handleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    let lengthValue = value.length;
    if (lengthValue > maxNumberOfCharacters) {
      value = value.substr(0, maxNumberOfCharacters);
    }
    setSelectedCity(value);
    onChangeCity();
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    let value: string = event.target.value;
    setSelectedCity(value.trim());
  }

  return (
    <form className={cx('root')} noValidate autoComplete="off">
      <div>
        <TextField
          disabled={readOnly}
          label="City"
          defaultValue={undefined}
          inputProps={{
            readOnly: readOnly
          }}
          variant="outlined"
          value={selectedCity}
          onInput={handleCityChange}
          onBlur={handleBlur}
          placeholder="Enter City."
          required={required}
        />
      </div>
    </form>
  );
}